<template>
    <div class="q-ma-xl ">
        <q-card class="shadow-0">
            <q-card-section>
                <div class=" row q-col-gutter-md">
                    <div class="col-12  text-center">
                        <img src="../../../public/LOGO_IMSS.png" width="180px" alt="">
                    </div>

                    <div class="col-12 col-md-3" v-for="a of listaVariables" :v-if="a.value == true" :key="a.variable">
                        <q-field bottom-slots outlined :value="item.numero_emp" :label="a.label" stack-label>
                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">{{ item[a.variable] }}</div>
                            </template>
                            <template v-slot:hint>
                                {{ a.info }}
                            </template>
                        </q-field>
                    </div>
                </div>
                <div class="row q-col-gutter-md justify-center q-mt-md">
                    <div class="col-12">
                        <div class="bg-grey full-width text-h5 text-white text-center">
                            EVIDENCIA FÍSICA
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <q-img src="https://picsum.photos/500/300" style="max-width: auto; height: auto;" contain>
                        </q-img>
                    </div>
                    <div class="col-12 col-md-3">
                        <q-img src="https://picsum.photos/500/300" style="max-width: auto; height: auto;" contain>
                        </q-img>
                    </div>
                    <div class="col-12 col-md-3">
                        <q-img src="https://picsum.photos/500/300" style="max-width: auto; height: auto;" contain>
                        </q-img>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>
<script>
import axios from "axios";
import { date, QSpinnerFacebook } from 'quasar'

export default {
    components: {
    },
    data() {
        return {
            item: { numero_emp: '' },
            listaVariables2: [],

            inv: '',
            unidad: '',
            _id: '',

            // http://localhost:8080/InfoQR/?inv=inv_oaxaca&unidad=67f93fb6124b0b19fa512e16&_id=67f93fb7124b0b19fa512e17
        }
    },
    mounted() {

    },
    computed: {
        listaVariables() {
            return this.listaVariables2
        }

    },
    created() {
        this.inv = this.$route.query.inv;
        this.unidad = this.$route.query.unidad;
        this._id = this.$route.query._id;
        // console.log("inv:", this.inv, "unidad:", this.unidad, "_id", this._id,);

        this.verDetallesItem();
        this.configQR();
    },
    methods: {
        async configQR() {
            this.dialoConfiguracion = true
            try {
                let response = await axios.get(`Configuracion/GetDatosQR/config_inventarios`);
                console.log(response)
                this.listaVariables2 = response.data
            } catch (error) {
                console.log(error)
            }
        },

        async verDetallesItem() {
            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Consultando Datos. Espere...', messageColor: 'white' })

            let obj = {
                bd_estado: this.inv,
                tabla_unidad: this.unidad
            }
            console.log(obj)
            try {
                let respuesa = await axios.post('Configuracion/GetBienWebXid/' + this._id, obj)
                console.log(respuesa)
                this.$q.loading.hide()
                this.item = { ...respuesa.data }
                this.dialogBien = true
            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
    }
}
</script>
<style>
body {
    background-color: rgb(226, 255, 255);
}
</style>